module.exports = __webpack_public_path__ + "img/pcBanner20.13e5b727.png";